import React, { useMemo } from 'react'

const HandleModel = ({ doorWidth, doorColor }) => {

  return (
    <group>
        <mesh position={[doorWidth / 20, -0.05, 0.15]} rotation={[Math.PI / 2, 0, 0]}>
            <cylinderGeometry args={[0.04, 0.04, 0.3, 8, 1]} />
            <meshStandardMaterial color={doorColor} roughness={0.2} metalness={0.3} />
        </mesh>
        <mesh position={[doorWidth / 20, 0.05, 0.15]} rotation={[Math.PI / 2, 0, 0]}>
            <cylinderGeometry args={[0.04, 0.04, 0.3, 8, 1]} />
            <meshStandardMaterial color={doorColor} roughness={0.2} metalness={0.3} />
        </mesh>
    </group>
  )
}

export default HandleModel